import React, { memo } from 'react'
import { Box, Typography } from 'transfix-ui/core'
import { IDriver, Maybe } from 'types/FMSGraphqlTypes'
import { VarianceFlagIcon } from 'transfix-icons'
import { brandColors } from 'transfix-ui'

interface IDriversProps {
  drivers: Maybe<Pick<IDriver, 'name'>[]>
  isExternal: boolean
}

export const Drivers = memo<IDriversProps>(({ drivers, isExternal }) => {
  const [firstDriver, secondDriver] = drivers || []
  const { name: firstDriverName } = firstDriver || {}
  const { name: secondDriverName } = secondDriver || {}

  return (
    <>
      {firstDriverName && (
        <Typography variant='body2' component='div'>
          {firstDriverName || 'unassigned'}
        </Typography>
      )}
      {!firstDriverName && !isExternal && (
        <Typography variant='body2' component='div' color={brandColors.coolGray5}>
          unassigned
        </Typography>
      )}
      {!firstDriverName && isExternal && (
        <Box display='flex' alignItems='center'>
          <Box marginRight='8px'>
            <VarianceFlagIcon size='xlarge' color='warning1' />
          </Box>
          <Box>
            <Typography variant='caption' component='div' color={brandColors.warning1}>
              At risk of losing load
            </Typography>
            <Typography variant='body2' component='div' color={brandColors.warning1}>
              Driver Needed
            </Typography>
          </Box>
        </Box>
      )}
      {secondDriverName && (
        <Typography variant='body2' component='div'>
          {secondDriverName}
        </Typography>
      )}
    </>
  )
})
